import supabaseClient from '@/api/supabaseClient.ts';
import { SupabaseClient } from '@supabase/supabase-js';
import { useQuery } from '@tanstack/react-query';
import { Reservation } from '@/types/models/Reservation';

type Filters =
  | {
      restaurant_id?: number | null;
      id?: number | null;
    }
  | undefined;
const useReservations = (enabled: boolean = true, filters: Filters = undefined) => {
  const client = supabaseClient;
  const queryKey = ['reservations', filters?.restaurant_id, filters?.id];

  const queryFn = async () => {
    return getReservations(client, filters);
  };

  return useQuery({
    queryKey,
    queryFn,
    enabled,
    staleTime: 1000 * 60 * 5,
  });
};

export default useReservations;

function getReservations(client: SupabaseClient, filters: Filters): Reservation[] {
  let clientWithFilters = client
    .from('reservations')
    .select(
      `
        id,
        client,
        restaurant_id ( id, name, address, phone, created_at ),
        phone,
        date,
        people,
        status,
        created_at
      `
    )
    .order('date', { ascending: true });

  if (filters?.restaurant_id) {
    clientWithFilters = clientWithFilters.eq('restaurant_id', filters.restaurant_id);
  }

  if (filters?.id) {
    clientWithFilters = clientWithFilters.eq('id', filters.id);
  }

  return clientWithFilters.then((result: any) => result.data) as unknown as Reservation[];
}
